// src/App.js
import React, { useEffect, useState, useCallback } from "react";
//import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";

import { ThemeProvider, CssBaseline, StyledEngineProvider } from "@mui/material";

import NavigationScroll from "layout/NavigationScroll";
import Grid from "@mui/material/Grid";
import Loader from "./util/Loader";
import Home from "./Home";
import Routes from "routes";
//import theme from "./theme"; 
import bbfTheme from "./theme/bbfTheme";

function App() {
  const [loading, setLoading] = useState(false);
  const [authorizedUser, setAuthorizedUser] = useState(false);

  //const customization = useSelector((state) => state.customization);
  const baseUri = process.env.REACT_APP_API_URL;

  const location = useLocation();
  const pageRoute = location.pathname.split("/");
  const pageName = pageRoute[1];

  // build theme with customization
  //const theme = useMemo(() => themeBuilder(customization), [customization]);

  const showModal = () => setLoading(true);
  const hideModal = () => setLoading(false);

  const getAuthorizedUser = useCallback(async () => {
    showModal();
    try {
      const endpoint = `${baseUri}/queries/`;
      await axios.get(endpoint, { withCredentials: true });
      setAuthorizedUser(true);
    } catch (e) {
      setAuthorizedUser(false);
    }
    hideModal();
  }, [baseUri]);

  useEffect(() => {
    getAuthorizedUser();
  }, [getAuthorizedUser]);

  const isChartPage =
    pageName === "columnchart" ||
    pageName === "columnchartfiltered" ||
    pageName === "portalview" ||
    pageName === "dashboard" ||
    pageName === "vecap" ||
    pageName === "stackedcolumnchart" ||
    pageName === "linechart" ||
    pageName === "vkd-assistant" ||
    pageName === "piechart" ||
    pageName === "materialdatagrid";

  return (
    <>
      <Loader open={loading} />

      {isChartPage ? (
        <Routes />
      ) : authorizedUser ? (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={bbfTheme}>
            <CssBaseline />
            <NavigationScroll>
              <Routes />
            </NavigationScroll>
          </ThemeProvider>
        </StyledEngineProvider>
      ) : (
        <Grid>
          <Grid item>
            <Home />
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default App;





